import { ListPageSkeleton, type ListPageSkeletonProps } from './ListPageSkeleton';
import type { ReactElement } from 'react';

type ListPageSkeletonVariant =
  | 'executionRuns'
  | 'uploads'
  | 'suites'
  | 'tests'
  | 'pipelines'
  | 'features'
  | 'releases';

type ListPageSkeletonPresetProps = {
  variant: ListPageSkeletonVariant;
  showDateRange?: boolean;
  chartHeight?: number;
};

const PRESETS: Record<ListPageSkeletonVariant, ListPageSkeletonProps> = {
  executionRuns: {
    titleWidth: 160,
    showSearch: true,
    showChart: true,
    chartTabsCount: 4,
    showTabs: true,
    tabCount: 3,
    statusCardCount: 5,
    metricCardCount: 3,
    chartTopGap: 'sm',
    chartBottomGap: 'none',
    sectionGap: 'md',
  },
  uploads: {
    titleWidth: 160,
    showSearch: true,
    showChart: true,
    chartTabsCount: 4,
    showTabs: true,
    tabCount: 3,
    statusCardCount: 5,
    metricCardCount: 3,
    chartTopGap: 'sm',
    chartBottomGap: 'none',
    sectionGap: 'md',
  },
  suites: {
    titleWidth: 160,
    showSearch: true,
    showChart: true,
    chartTabsCount: 4,
    showTabs: true,
    tabCount: 2,
    statusCardCount: 6,
    metricCardCount: 3,
    chartTopGap: 'sm',
    chartBottomGap: 'none',
    sectionGap: 'md',
  },
  tests: {
    titleWidth: 140,
    showSearch: true,
    showChart: true,
    chartTabsCount: 4,
    showTabs: true,
    tabCount: 2,
    statusCardCount: 6,
    metricCardCount: 3,
    chartTopGap: 'sm',
    chartBottomGap: 'none',
    sectionGap: 'md',
  },
  pipelines: {
    titleWidth: 160,
    showSearch: true,
    showChart: true,
    chartTabsCount: 1,
    showTabs: true,
    tabCount: 2,
    statusCardCount: 6,
    chartTopGap: 'sm',
    chartBottomGap: 'none',
    sectionGap: 'md',
  },
  features: {
    titleWidth: 150,
    statusCardCount: 6,
  },
  releases: {
    titleWidth: 160,
    statusCardCount: 6,
  },
};

export const ListPageSkeletonPreset = ({
  variant,
  showDateRange,
  chartHeight,
}: ListPageSkeletonPresetProps): ReactElement => {
  const baseProps = PRESETS[variant];
  const resolvedProps: ListPageSkeletonProps = {
    ...baseProps,
    ...(showDateRange !== undefined ? { showDateRange } : {}),
    ...(chartHeight !== undefined ? { chartHeight } : {}),
  };

  return <ListPageSkeleton {...resolvedProps} />;
};
